import * as fcl from "@onflow/fcl"
import React, { useEffect } from "react"
import { Helmet } from "react-helmet-async"
import { ReactComponent as FlowtyLogo } from "../assets/media/flowty_logo.svg"

// Flowty has wound down; sign out any lingering wallet session so nothing
// on the client still considers the user logged in.
const clearExistingSession = (): void => {
	try {
		localStorage.removeItem("FCL_CURRENT_USER")
		sessionStorage.clear()
		fcl.unauthenticate()
	} catch {
		// nothing to clean up
	}
}

export const ShutdownScreen: React.FunctionComponent = () => {
	useEffect(clearExistingSession, [])

	return (
		<>
			<Helmet>
				<title>Flowty</title>
				<meta
					name='description'
					content='The Flowty Marketplace is no longer available.'
				/>
			</Helmet>
			<main className='min-h-screen w-full bg-darkBg flex flex-col items-center justify-center px-4 text-center'>
				<FlowtyLogo
					className='w-64 sm:w-96 h-auto'
					role='img'
					aria-label='Flowty'
				/>
				<h1 className='mt-12 text-3xl sm:text-4xl font-extrabold text-gray-200 tracking-tight'>
					The Flowty Marketplace is No Longer Available
				</h1>
				<p className='mt-4 max-w-xl text-lg text-gray-400'>
					Thank you to our incredible community. We greatly appreciate your
					support and loyalty over the years.
				</p>
			</main>
		</>
	)
}
